<div class="scad-drag-area__side-section" [ngClass]="{'small': !_flowBuilder.isLong}">
    <div class="scad-drag-sidemenu" >

      <div *ngIf="lastSelectedNodeType===nodeTypes?.source"><app-source-node></app-source-node></div>
      <!-- <div *ngIf="lastSelectedNodeType===nodeTypes?.source"><app-auto-ml></app-auto-ml></div> -->
      <div *ngIf="lastSelectedNodeType===nodeTypes?.target"><app-target-node></app-target-node></div>
      <div *ngIf="lastSelectedNodeType===nodeTypes?.select"><app-select-node></app-select-node></div>
      <div *ngIf="lastSelectedNodeType===nodeTypes?.filter"><app-filter-node></app-filter-node></div>
      <div *ngIf="lastSelectedNodeType===nodeTypes?.join"><app-join-node></app-join-node></div>

    </div>
    <svg (click)="_flowBuilder.isLong = !_flowBuilder.isLong"  [ngClass]="{'toggle-on': _flowBuilder.isLong}" class="toggle" xmlns="http://www.w3.org/2000/svg" width="53" height="21" viewBox="0 0 53 21" fill="none">
      <rect x="53" width="21" height="53" rx="10.5" transform="rotate(90 53 0)" fill="#9DA2AE"/>
      <path d="M23.1001 12.4429L26.2337 16.4095L29.3334 12.4429" stroke="white" stroke-width="1.61905" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M29.3335 8.39502L26.1999 4.42835L23.1002 8.39502" stroke="white" stroke-width="1.61905" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</div>


